<template>
  <div>
    <!-- 面包屑 -->
    <div class="breadcrumb">
      <div class="item">抽查任务</div>
      <div class="item" @click="$parent.isCreate = false"><span>/</span>任务列表</div>
      <div class="item"><span>/</span>创建任务</div>
    </div>
    <div class="body">
      <!-- 到货核查抽查  -->
      <arrival :options="options" :taskType="taskType" :adminList="adminList" :executeTypeList="executeTypeList"
        v-if="taskType == 1" />
      <!-- 检品操作抽查  -->
      <inspectionOperation :options="options" :taskType="taskType" :adminList="adminList"
        :executeTypeList="executeTypeList" v-if="taskType == 2" />
      <!-- 在库货物 -->
      <goodsInStock :options="options" :taskType="taskType" :adminList="adminList" :executeTypeList="executeTypeList"
        v-if="taskType == 3" />
      <!-- FBA操作 贴标前，贴标中，贴标后-->
      <fbaOperation :options="options" :taskType="taskType" :adminList="adminList" :executeTypeList="executeTypeList"
        v-if="[4, 5, 6].includes(taskType)" />
      <!-- 待出货包裹 -->
      <pendingShipmentPackages :options="options" :taskType="taskType" :adminList="adminList"
        :executeTypeList="executeTypeList" v-if="taskType == 7" />
      <!-- 已出货配送单 -->
      <shippedPorder :options="options" :taskType="taskType" :adminList="adminList" :executeTypeList="executeTypeList"
        v-if="taskType == 8" />
      <!-- 已出货配送单 -->
      <shipmentSite :options="options" :taskType="taskType" :adminList="adminList" :executeTypeList="executeTypeList"
        v-if="taskType == 9" />
      <!-- 商品退货 -->
      <productReturn :options="options" :taskType="taskType" :adminList="adminList" :executeTypeList="executeTypeList"
        v-if="taskType == 10" />
    </div>
  </div>
</template>
<script>
import arrival from './components/arrival'
import inspectionOperation from './components/inspectionOperation'
import goodsInStock from './components/goodsInStock'
import fbaOperation from './components/fbaOperation'
import pendingShipmentPackages from './components/pendingShipmentPackages'
import shippedPorder from './components/shippedPorder'
import productReturn from './components/productReturn'
import shipmentSite from './components/shipmentSite'
export default {
  components: {
    arrival,
    inspectionOperation,
    goodsInStock,
    fbaOperation,
    pendingShipmentPackages,
    shippedPorder,
    productReturn,
    shipmentSite
  },
  props: {
    taskType: { type: [Number, String] },
    options: { type: Array },
    adminList: { type: Array },
    executeTypeList: { type: Array },
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.breadcrumb {
  background-color: #f8f8f8;
  padding: 18px 20px;
  margin-bottom: 15px;
  display: flex;

  .item {
    color: #666666;
    cursor: pointer;

    &:nth-last-child(1) {
      color: #222;
    }

    span {
      margin: 0 10px;

    }
  }
}
</style>